import React, { useEffect, useState } from 'react';
import { Modal, Button, Form, Row, Col, Alert } from 'react-bootstrap';
import { FaExclamationTriangle } from 'react-icons/fa';
import { NFService } from '../../../services/tipos';

interface ModalCancelarNotaProps {
    show: boolean;
    onHide: () => void;
    nota: NFService | null;
    onConfirm: (motivo: string) => Promise<void>;
}

const ModalCancelarNota: React.FC<ModalCancelarNotaProps> = ({ show, onHide, nota, onConfirm }) => {
    const [motivo, setMotivo] = useState('');
    const [countdown, setCountdown] = useState(5);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (show) {
            setMotivo('');
            setCountdown(5);
            setLoading(false);
            
            const timer = setInterval(() => {
                setCountdown((prev) => (prev > 0 ? prev - 1 : 0));
            }, 1000);

            return () => clearInterval(timer);
        }
    }, [show]);

    const handleConfirm = async () => {
        if (!motivo.trim()) return;
        
        setLoading(true);
        await onConfirm(motivo);
        setLoading(false);
    };

    if (!nota) return null;

    return (
        <Modal show={show} onHide={onHide} centered backdrop="static" keyboard={false}>
            <Modal.Header>
                <Modal.Title>Cancelar Nota Fiscal</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Alert variant="warning">
                    <FaExclamationTriangle className="me-2" />
                    Atenção! Esta ação é irreversível. A nota será cancelada na prefeitura.
                </Alert>

                <div className="mb-4">
                    <Row>
                        <Col xs={6}>
                            <strong>Número (RPS):</strong> <br /> {nota.numeroNota || '-'}
                        </Col>
                        <Col xs={6}>
                            <strong>Protocolo:</strong> <br /> {nota.protocolo || '-'}
                        </Col>
                    </Row>
                    <Row className="mt-2">
                        <Col xs={12}>
                            <strong>Locatário:</strong> <br /> {nota.nomeLocatario}
                        </Col>
                    </Row>
                    <Row className="mt-2">
                        <Col xs={12}>
                            <strong>Valor:</strong> <br /> 
                            {nota.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                        </Col>
                    </Row>
                </div>

                <Form.Group controlId="motivoCancelamento">
                    <Form.Label><strong>Motivo do Cancelamento</strong> (Obrigatório)</Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={3}
                        value={motivo}
                        onChange={(e) => setMotivo(e.target.value)}
                        placeholder="Informe o motivo do cancelamento conforme exigência da prefeitura..."
                        disabled={loading}
                    />
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide} disabled={loading}>
                    Fechar
                </Button>
                <Button 
                    variant="danger" 
                    onClick={handleConfirm}
                    disabled={countdown > 0 || !motivo.trim() || loading}
                >
                    {loading ? 'Cancelando...' : countdown > 0 ? `Aguarde ${countdown}s` : 'Confirmar Cancelamento'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalCancelarNota;